import { ComplementaryProductComponent } from './complementary-product.component';

export const ComplementaryProduct = ComplementaryProductComponent;
